import _ from 'lodash';

const THREE = require('three');


let max = (key, value, statistic) => {
    const prevValue = statistic[key];
    return prevValue === undefined || prevValue < value ? value: prevValue;
};

let min = (key, value, statistic) => {
    const prevValue = statistic[key];
    return prevValue === undefined || prevValue > value ? value: prevValue;
};

function generateBoundary(boundary) {
    let geometry = new THREE.Geometry();
    let statistic = {};


    let processCoordinate = (key, value) => {
        const maxKey = `max${key}`;
        const minKey = `min${key}`;
        statistic[maxKey] = max(maxKey, value, statistic);
        statistic[minKey] = min(minKey, value, statistic);
    };

    boundary.polygons.forEach(function(poly) {
        const [x, y, z] = poly;
        processCoordinate('X', x);
        processCoordinate('Y', y);
        processCoordinate('Z', z);
        geometry.vertices.push(new THREE.Vector3(x,  y, z));
    });
    return [statistic, geometry];
}

function getSiftDistance(statistics, edges) {
    return statistics.maxZ - statistics.minZ + edges.bridgeSpan;
}

function shiftCoordinates(boundary, distance) {
    return {
        polygons: boundary.polygons.map(function (dot) {
            let [x, y, z] = dot;
            return [x, y, z + distance];
        })
    };
}

function shiftRowCoordinates(boundaries, distance) {
    let results = [];
    boundaries.forEach(function(boundary) {
        results.push(shiftCoordinates(boundary, distance));
    });
    return results;
}

function calculateBoundariesStatistic(boundariesData) {
    let results = {};
    boundariesData.forEach(function(boundary) {
      const [statistic,] = boundary;
      results.maxX = max('maxX', results.maxX, statistic);
      results.minX = min('minX', results.minX, statistic);
      results.maxZ = max('maxZ', results.maxZ, statistic);
      results.minZ = min('minZ', results.minZ, statistic);
    });
    results.dimentionX  = results.maxX - results.minX;
    results.dimentionZ  = results.maxZ - results.minZ;
    results.middleX  = results.maxX - results.dimentionX/2;
    results.middleZ  = results.maxZ - results.dimentionZ/2;
    return results;
}

function cloneBoundaries(boundaries, edges, pitch) {
    let results =  boundaries.map(function(boundary) {
        return generateBoundary(boundary);
    });
    let newBoundaries  = _.concat(shiftRowCoordinates(boundaries, pitch), shiftRowCoordinates(boundaries, -pitch));
    let result = _.concat(results, newBoundaries.map(function(boundary) {
        return generateBoundary(boundary);
    }));
    return result;
}

function generateBoundaries(boundaries, edges, pitch) {
    const boundariesData =  cloneBoundaries(boundaries, edges, pitch);
    return [
        calculateBoundariesStatistic(boundariesData),
        boundariesData
    ];
}

export {generateBoundaries, generateBoundary};



// WEBPACK FOOTER //
// ./client/app/common/model-view/boundaries.js